// Banners da home (CarouselGeneric).
// mobileAspectRatio (opcional): proporção "largura / altura" da arte mobile.
// Sem ele, o banner mobile usa a altura fixa padrão (197px).
export const images = [
  {
    desktop: "https://cdn.meucupom.com/media/2026%20-%20Updates/black_friday/desktop-black.jpg",
    mobile: "https://cdn.meucupom.com/media/2026%20-%20Updates/black_friday/mobile-black.jpg",
    mobileAspectRatio: "720 / 750",
    url: "/cupom-desconto-black-friday?utm_source=black_friday_2026&utm_medium=banner&utm_campaign=black_friday_2026&utm_content=home_banner",
  },
  // {
  //   desktop: "https://static.meucupom.com/media/2026%20-%20Updates/banner%20home/10-10/10-10-meucupom-desktop.jpg",
  //   mobile: "https://static.meucupom.com/media/2026%20-%20Updates/banner%20home/10-10/10-10-meucupom-mobile.jpg",
  //   url: "/cupom-desconto-oferta-do-dia?utm_source=home&utm_medium=banner&utm_campaign=10-10&utm_content=10-10",
  // },
  // {
  //   desktop: "https://static.meucupom.com/media/2026%20-%20Updates/calcados/desktop.jpg",
  //   mobile: "https://static.meucupom.com/media/2026%20-%20Updates/calcados/mobile.jpg",
  //   url: "/cupom-desconto-esportes?utm_source=home&utm_medium=banner&utm_campaign=esporte&utm_content=esporte",
  // },
  // {
  //   desktop: "https://static.meucupom.com/media/2026%20-%20Updates/iphone-18/iphone%20desktop.jpg",
  //   mobile: "https://static.meucupom.com/media/2026%20-%20Updates/iphone-18/iphone%20mobile.jpg",
  //   url: "/cupom-desconto-smartphone-tablet?utm_source=home&utm_medium=banner&utm_campaign=iphone-18&utm_content=iphone-18",
  // },
];
